import React from "react";
import {
  Box,
  Typography,
  Grid,
  Modal,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { SxProps, Theme } from "@mui/material";
import { toPascalCase } from "../../utils/formatting";
import InfoIcon from "./../../assets/images/icons/info.png";
import { formatDate } from "../../utils/dateFormatUtils";
// Props for modal
interface ModelViewReplicaProps {
  rows: any;
  openModal: boolean;
  onCloseFun: () => void;
}
const Card = styled(Box)(() => ({
  border: "1px solid #E0E0E0",
  borderRadius: "8px",
  backgroundColor: "#fff",
  boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
}));

const ModelViewForMobile: React.FC<ModelViewReplicaProps> = ({
  rows,
  openModal,
  onCloseFun,
}) => {
    const StatusBadge = styled("span")<{
  statusColor: string;
  backgroundColor: string;
}>(({ statusColor, backgroundColor }) => ({
  color: statusColor,
  textTransform: "capitalize",
  backgroundColor,
  textAlign: "left",
  width: "110px",
  padding: "4px 1px",
  borderRadius: "4px",
  fontSize: "14px",
  fontWeight: 500,
  border: "none",
  display: "inline-block",
}));
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const modalStyle: SxProps<Theme> = isMobile
    ? {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: "background.paper",
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
        boxShadow: "0px -2px 10px rgba(0,0,0,0.2)",
        maxHeight: "85vh",
        overflowY: "auto",
        p: 2,
      }
    : {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "70%",
        bgcolor: "background.paper",
        borderRadius: "12px",
        boxShadow: 24,
        p: 3,
      };

  return (
    <Modal open={openModal} onClose={onCloseFun}>
      <Box sx={modalStyle}>
        {isMobile && (
          <Box
            sx={{
              width: 40,
              height: 4,
              backgroundColor: "#ccc",
              borderRadius: "2px",
              mx: "auto",
              mb: 2,
            }}
          />
        )}

        <Typography variant="subtitle1" fontWeight={600} mb={2}>
          View details
        </Typography>

        {/* Content */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9}>
            <Card sx={{ p: 2, backgroundColor: "#f9f9f9" }}>
              <Box
                sx={{
                  borderBottom: "none",
                  pb: 2,
                  mb: 2,
                }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Typography variant="caption" color="text.secondary">
                      Request ID
                    </Typography>
                    <Typography fontWeight={600}>
                      {rows?.referenceNumber}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="caption" color="text.secondary">
                      Disbursement Amount
                    </Typography>
                    <Typography fontWeight={600}>
                      INR {rows?.disbursedAmount}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="caption" color="text.secondary">
                      Disbursement Type
                    </Typography>
                    <Typography fontWeight={600}>
                      {rows &&
                        rows?.lienValues &&
                        rows?.lienValues
                          .map((item: any) => `${toPascalCase(item.type)}`)
                          .join(" + ")}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Grid>
          {/* Right Details Card */}
          <Grid item xs={12} sm={9}>
            <Card sx={{ p: 2 }}>
              {rows &&
                rows?.lienValues &&
                rows?.lienValues?.map((item: any, index: number) => (
                  <Box
                    key={index}
                    sx={{
                      borderBottom:
                        index !== rows.lienValues.length - 1
                          ? "1px solid #eee"
                          : "none",
                      pb: 2,
                      mb: 2,
                    }}
                  >
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">
                          Disbursement Type
                        </Typography>
                        <Typography fontWeight={600}>
                          {item.type=="lien"?"Fund Release from Lien A/c":item?.type=="tranche"?"New Tranche":""}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">
                          Amount
                        </Typography>
                        <Typography fontWeight={600}>INR {item.amount}</Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">
                          Status
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1}>
                          <StatusBadge
                            statusColor="#EA5455"
                            backgroundColor={
                              item?.status === "approved" 
                                ? "#b4ffd5"
                                : item?.status?.toLowerCase() === "pending" ||
                                  item?.status?.toLowerCase() === "rejected" 
                                ? "rgba(234, 84, 85, 0.2)"
                                : rows?.status === "query"
                                ? "#eaeaea"
                                : "rgba(8, 7, 7, 0.2)"
                            }
                          >
                            <span
                              style={{
                                color:
                                  item?.status === "approved" 
                                    ? "#28C76F"
                                    : item?.status?.toLowerCase() ===
                                        "pending" 
                                    ? "#EA5455"
                                    : rows?.status === "query"
                                    ? "rgb(28, 177, 177)"
                                    : "#EA5455",
                                textTransform: "capitalize",
                                marginLeft: "8px",
                              }}
                            >
                              {item.status}
                            </span>
                          </StatusBadge>
                        </Box>
                        {item?.status?.toLowerCase() == "pending" && (
                                <p style={{color:"red"}}>
                                { item?.BankUploadStatus
                                    ? item?.BankUploadStatus
                                    : "Pending From Avanse"}
                                </p>
                            )}
                        {item.type === "lien" &&
                            item?.status?.toLowerCase() == "rejected" &&
                            item?.remark?.length>0 && (item?.remark?.filter((rem:any)=>rem?.remark!=rows?.remark && rows?.remark!="")[0]?.remark || item?.remark?.length==1 ) && (
                            <p style={{color:"red"}}>
                                {item?.remark?.length==1?rows?.remark:item?.remark?.filter((rem:any)=>rem?.remark!=rows?.remark && rows?.remark!="")[0]?.remark}
                            </p>
                            )}
                        {item.type === "tranche" &&
                            item?.status?.toLowerCase() === "rejected" && (
                            <p style={{color:"red"}}>
                                { rows?.remark}
                            </p>
                        )}
                      </Grid>

                      <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">
                          Disbursement Date
                        </Typography>
                        <Typography fontWeight={600}>
                          {item.type==="tranche" && rows?.disbursemntDate ? formatDate(rows?.disbursemntDate) : item?.disbDate ? formatDate(item?.disbDate):""}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                ))}
            </Card>
          </Grid>
        </Grid>

        {/* Footer */}
        <Box mt={2}>
          <Typography variant="subtitle2" fontWeight={600}>
            Final Disbursed Amount: 
            {rows?.lienValues
                ?.filter((item: any) => item.status === "approved")
                .reduce((sum: any, item: any) => sum + Number(item.amount), 0) === 0
                ? " NA"
                : ` INR ${rows?.lienValues
                    ?.filter((item: any) => item.status === "approved")
                    .reduce((sum: any, item: any) => sum + Number(item.amount), 0)}`}
          </Typography>
        </Box>

        {/* Close button */}
        <Box mt={2} textAlign="center">
          <Box
            component="button"
            onClick={onCloseFun}
            style={{
              backgroundColor: "#00B8A9",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              padding: "12px 20px",
              cursor: "pointer",
              width: "100%",
              fontWeight: 600,
            }}
          >
            Close
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModelViewForMobile;
